import { render, staticRenderFns } from "./services-overview.vue?vue&type=template&id=ca945fa2"
import script from "./services-overview.vue?vue&type=script&lang=js"
export * from "./services-overview.vue?vue&type=script&lang=js"
import style0 from "./services-overview.vue?vue&type=style&index=0&id=ca945fa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports